import * as React from 'react';
import { useRef, useState, useCallback, createElement, useEffect } from 'react';
import { _ as _objectSpread2, b as _objectWithoutPropertiesLoose } from './_rollupPluginBabelHelpers-cb1cd42c.js';
import { useOptions, useProps } from 'reakit-system';
import * as ReactDOM from 'react-dom';
import { unmountComponentAtNode, render } from 'react-dom';
import * as system from 'reakit-system-bootstrap';
import { unstable_useId, Provider } from 'reakit';
import { transform } from 'buble';
import { ErrorMessage } from './ErrorMessage.js';
import { ErrorBoundary } from './ErrorBoundary.js';

/* eslint-disable */
// Automatically generated
var ReakitPlayground = {
  "reakit-playground": require("reakit-playground"),
  "reakit-playground/ErrorBoundary": require("reakit-playground/ErrorBoundary"),
  "reakit-playground/ErrorMessage": require("reakit-playground/ErrorMessage"),
  "reakit-playground/PlaygroundEditor": require("reakit-playground/PlaygroundEditor"),
  "reakit-playground/PlaygroundPreview": require("reakit-playground/PlaygroundPreview"),
  "reakit-playground/system": require("reakit-playground/system"),
  "reakit-playground/usePlaygroundState": require("reakit-playground/usePlaygroundState")
};

/* eslint-disable */
// Automatically generated
var ReakitSystemBootstrap = {
  "reakit-system-bootstrap": require("reakit-system-bootstrap"),
  "reakit-system-bootstrap/Button": require("reakit-system-bootstrap/Button"),
  "reakit-system-bootstrap/Composite": require("reakit-system-bootstrap/Composite"),
  "reakit-system-bootstrap/Dialog": require("reakit-system-bootstrap/Dialog"),
  "reakit-system-bootstrap/Form": require("reakit-system-bootstrap/Form"),
  "reakit-system-bootstrap/Group": require("reakit-system-bootstrap/Group"),
  "reakit-system-bootstrap/Input": require("reakit-system-bootstrap/Input"),
  "reakit-system-bootstrap/Menu": require("reakit-system-bootstrap/Menu"),
  "reakit-system-bootstrap/Popover": require("reakit-system-bootstrap/Popover"),
  "reakit-system-bootstrap/Role": require("reakit-system-bootstrap/Role"),
  "reakit-system-bootstrap/Separator": require("reakit-system-bootstrap/Separator"),
  "reakit-system-bootstrap/Tab": require("reakit-system-bootstrap/Tab"),
  "reakit-system-bootstrap/Tabbable": require("reakit-system-bootstrap/Tabbable"),
  "reakit-system-bootstrap/Toolbar": require("reakit-system-bootstrap/Toolbar"),
  "reakit-system-bootstrap/Tooltip": require("reakit-system-bootstrap/Tooltip"),
  "reakit-system-bootstrap/palette": require("reakit-system-bootstrap/palette")
};

/* eslint-disable */
// Automatically generated
var ReakitSystemPalette = {
  "reakit-system-palette": require("reakit-system-palette"),
  "reakit-system-palette/Role": require("reakit-system-palette/Role"),
  "reakit-system-palette/palette": require("reakit-system-palette/palette"),
  "reakit-system-palette/utils": require("reakit-system-palette/utils"),
  "reakit-system-palette/utils/contrast": require("reakit-system-palette/utils/contrast"),
  "reakit-system-palette/utils/darken": require("reakit-system-palette/utils/darken"),
  "reakit-system-palette/utils/fade": require("reakit-system-palette/utils/fade"),
  "reakit-system-palette/utils/isDark": require("reakit-system-palette/utils/isDark"),
  "reakit-system-palette/utils/isLight": require("reakit-system-palette/utils/isLight"),
  "reakit-system-palette/utils/lighten": require("reakit-system-palette/utils/lighten"),
  "reakit-system-palette/utils/palette": require("reakit-system-palette/utils/palette"),
  "reakit-system-palette/utils/ref": require("reakit-system-palette/utils/ref")
};

/* eslint-disable */
// Automatically generated
var ReakitSystem = {
  "reakit-system": require("reakit-system"),
  "reakit-system/SystemContext": require("reakit-system/SystemContext"),
  "reakit-system/SystemProvider": require("reakit-system/SystemProvider"),
  "reakit-system/createComponent": require("reakit-system/createComponent"),
  "reakit-system/createHook": require("reakit-system/createHook"),
  "reakit-system/mergeSystem": require("reakit-system/mergeSystem"),
  "reakit-system/useCreateElement": require("reakit-system/useCreateElement"),
  "reakit-system/useOptions": require("reakit-system/useOptions"),
  "reakit-system/useProps": require("reakit-system/useProps"),
  "reakit-system/useToken": require("reakit-system/useToken")
};

/* eslint-disable */
// Automatically generated
var ReakitUtils = {
  "reakit-utils": require("reakit-utils"),
  "reakit-utils/applyState": require("reakit-utils/applyState"),
  "reakit-utils/canUseDOM": require("reakit-utils/canUseDOM"),
  "reakit-utils/closest": require("reakit-utils/closest"),
  "reakit-utils/contains": require("reakit-utils/contains"),
  "reakit-utils/createEvent": require("reakit-utils/createEvent"),
  "reakit-utils/createOnKeyDown": require("reakit-utils/createOnKeyDown"),
  "reakit-utils/dom": require("reakit-utils/dom"),
  "reakit-utils/ensureFocus": require("reakit-utils/ensureFocus"),
  "reakit-utils/fireBlurEvent": require("reakit-utils/fireBlurEvent"),
  "reakit-utils/fireEvent": require("reakit-utils/fireEvent"),
  "reakit-utils/fireKeyboardEvent": require("reakit-utils/fireKeyboardEvent"),
  "reakit-utils/flatten": require("reakit-utils/flatten"),
  "reakit-utils/getActiveElement": require("reakit-utils/getActiveElement"),
  "reakit-utils/getDocument": require("reakit-utils/getDocument"),
  "reakit-utils/getNextActiveElementOnBlur": require("reakit-utils/getNextActiveElementOnBlur"),
  "reakit-utils/getWindow": require("reakit-utils/getWindow"),
  "reakit-utils/hasFocus": require("reakit-utils/hasFocus"),
  "reakit-utils/hasFocusWithin": require("reakit-utils/hasFocusWithin"),
  "reakit-utils/isButton": require("reakit-utils/isButton"),
  "reakit-utils/isEmpty": require("reakit-utils/isEmpty"),
  "reakit-utils/isInteger": require("reakit-utils/isInteger"),
  "reakit-utils/isObject": require("reakit-utils/isObject"),
  "reakit-utils/isPlainObject": require("reakit-utils/isPlainObject"),
  "reakit-utils/isPortalEvent": require("reakit-utils/isPortalEvent"),
  "reakit-utils/isPromise": require("reakit-utils/isPromise"),
  "reakit-utils/isSelfTarget": require("reakit-utils/isSelfTarget"),
  "reakit-utils/isTextField": require("reakit-utils/isTextField"),
  "reakit-utils/matches": require("reakit-utils/matches"),
  "reakit-utils/normalizePropsAreEqual": require("reakit-utils/normalizePropsAreEqual"),
  "reakit-utils/omit": require("reakit-utils/omit"),
  "reakit-utils/pick": require("reakit-utils/pick"),
  "reakit-utils/removeIndexFromArray": require("reakit-utils/removeIndexFromArray"),
  "reakit-utils/removeItemFromArray": require("reakit-utils/removeItemFromArray"),
  "reakit-utils/shallowEqual": require("reakit-utils/shallowEqual"),
  "reakit-utils/splitProps": require("reakit-utils/splitProps"),
  "reakit-utils/tabbable": require("reakit-utils/tabbable"),
  "reakit-utils/toArray": require("reakit-utils/toArray"),
  "reakit-utils/types": require("reakit-utils/types"),
  "reakit-utils/useForkRef": require("reakit-utils/useForkRef"),
  "reakit-utils/useIsomorphicEffect": require("reakit-utils/useIsomorphicEffect"),
  "reakit-utils/useLiveRef": require("reakit-utils/useLiveRef"),
  "reakit-utils/useSealedState": require("reakit-utils/useSealedState"),
  "reakit-utils/useUpdateEffect": require("reakit-utils/useUpdateEffect")
};

/* eslint-disable */
// Automatically generated
var Reakit = {
  "reakit": require("reakit"),
  "reakit/Box": require("reakit/Box"),
  "reakit/Box/Box": require("reakit/Box/Box"),
  "reakit/Button": require("reakit/Button"),
  "reakit/Button/Button": require("reakit/Button/Button"),
  "reakit/Checkbox": require("reakit/Checkbox"),
  "reakit/Checkbox/Checkbox": require("reakit/Checkbox/Checkbox"),
  "reakit/Checkbox/CheckboxState": require("reakit/Checkbox/CheckboxState"),
  "reakit/Clickable": require("reakit/Clickable"),
  "reakit/Clickable/Clickable": require("reakit/Clickable/Clickable"),
  "reakit/Combobox": require("reakit/Combobox"),
  "reakit/Combobox/Combobox": require("reakit/Combobox/Combobox"),
  "reakit/Combobox/ComboboxGridCell": require("reakit/Combobox/ComboboxGridCell"),
  "reakit/Combobox/ComboboxGridRow": require("reakit/Combobox/ComboboxGridRow"),
  "reakit/Combobox/ComboboxGridState": require("reakit/Combobox/ComboboxGridState"),
  "reakit/Combobox/ComboboxItem": require("reakit/Combobox/ComboboxItem"),
  "reakit/Combobox/ComboboxList": require("reakit/Combobox/ComboboxList"),
  "reakit/Combobox/ComboboxListGridState": require("reakit/Combobox/ComboboxListGridState"),
  "reakit/Combobox/ComboboxListState": require("reakit/Combobox/ComboboxListState"),
  "reakit/Combobox/ComboboxOption": require("reakit/Combobox/ComboboxOption"),
  "reakit/Combobox/ComboboxPopover": require("reakit/Combobox/ComboboxPopover"),
  "reakit/Combobox/ComboboxState": require("reakit/Combobox/ComboboxState"),
  "reakit/Composite": require("reakit/Composite"),
  "reakit/Composite/Composite": require("reakit/Composite/Composite"),
  "reakit/Composite/CompositeGroup": require("reakit/Composite/CompositeGroup"),
  "reakit/Composite/CompositeItem": require("reakit/Composite/CompositeItem"),
  "reakit/Composite/CompositeItemWidget": require("reakit/Composite/CompositeItemWidget"),
  "reakit/Composite/CompositeState": require("reakit/Composite/CompositeState"),
  "reakit/Dialog": require("reakit/Dialog"),
  "reakit/Dialog/Dialog": require("reakit/Dialog/Dialog"),
  "reakit/Dialog/DialogBackdrop": require("reakit/Dialog/DialogBackdrop"),
  "reakit/Dialog/DialogDisclosure": require("reakit/Dialog/DialogDisclosure"),
  "reakit/Dialog/DialogState": require("reakit/Dialog/DialogState"),
  "reakit/Disclosure": require("reakit/Disclosure"),
  "reakit/Disclosure/Disclosure": require("reakit/Disclosure/Disclosure"),
  "reakit/Disclosure/DisclosureContent": require("reakit/Disclosure/DisclosureContent"),
  "reakit/Disclosure/DisclosureState": require("reakit/Disclosure/DisclosureState"),
  "reakit/Form": require("reakit/Form"),
  "reakit/Form/Form": require("reakit/Form/Form"),
  "reakit/Form/FormCheckbox": require("reakit/Form/FormCheckbox"),
  "reakit/Form/FormGroup": require("reakit/Form/FormGroup"),
  "reakit/Form/FormInput": require("reakit/Form/FormInput"),
  "reakit/Form/FormLabel": require("reakit/Form/FormLabel"),
  "reakit/Form/FormMessage": require("reakit/Form/FormMessage"),
  "reakit/Form/FormPushButton": require("reakit/Form/FormPushButton"),
  "reakit/Form/FormRadio": require("reakit/Form/FormRadio"),
  "reakit/Form/FormRadioGroup": require("reakit/Form/FormRadioGroup"),
  "reakit/Form/FormRemoveButton": require("reakit/Form/FormRemoveButton"),
  "reakit/Form/FormState": require("reakit/Form/FormState"),
  "reakit/Form/FormSubmitButton": require("reakit/Form/FormSubmitButton"),
  "reakit/Form/utils": require("reakit/Form/utils"),
  "reakit/Form/utils/getIn": require("reakit/Form/utils/getIn"),
  "reakit/Form/utils/setAllIn": require("reakit/Form/utils/setAllIn"),
  "reakit/Form/utils/setIn": require("reakit/Form/utils/setIn"),
  "reakit/Grid": require("reakit/Grid"),
  "reakit/Grid/Grid": require("reakit/Grid/Grid"),
  "reakit/Grid/GridCell": require("reakit/Grid/GridCell"),
  "reakit/Grid/GridRow": require("reakit/Grid/GridRow"),
  "reakit/Grid/GridState": require("reakit/Grid/GridState"),
  "reakit/Group": require("reakit/Group"),
  "reakit/Group/Group": require("reakit/Group/Group"),
  "reakit/Id": require("reakit/Id"),
  "reakit/Id/Id": require("reakit/Id/Id"),
  "reakit/Id/IdProvider": require("reakit/Id/IdProvider"),
  "reakit/Id/IdState": require("reakit/Id/IdState"),
  "reakit/Input": require("reakit/Input"),
  "reakit/Input/Input": require("reakit/Input/Input"),
  "reakit/Menu": require("reakit/Menu"),
  "reakit/Menu/Menu": require("reakit/Menu/Menu"),
  "reakit/Menu/MenuArrow": require("reakit/Menu/MenuArrow"),
  "reakit/Menu/MenuBar": require("reakit/Menu/MenuBar"),
  "reakit/Menu/MenuBarState": require("reakit/Menu/MenuBarState"),
  "reakit/Menu/MenuButton": require("reakit/Menu/MenuButton"),
  "reakit/Menu/MenuDisclosure": require("reakit/Menu/MenuDisclosure"),
  "reakit/Menu/MenuGroup": require("reakit/Menu/MenuGroup"),
  "reakit/Menu/MenuItem": require("reakit/Menu/MenuItem"),
  "reakit/Menu/MenuItemCheckbox": require("reakit/Menu/MenuItemCheckbox"),
  "reakit/Menu/MenuItemRadio": require("reakit/Menu/MenuItemRadio"),
  "reakit/Menu/MenuSeparator": require("reakit/Menu/MenuSeparator"),
  "reakit/Menu/MenuState": require("reakit/Menu/MenuState"),
  "reakit/Popover": require("reakit/Popover"),
  "reakit/Popover/Popover": require("reakit/Popover/Popover"),
  "reakit/Popover/PopoverArrow": require("reakit/Popover/PopoverArrow"),
  "reakit/Popover/PopoverBackdrop": require("reakit/Popover/PopoverBackdrop"),
  "reakit/Popover/PopoverDisclosure": require("reakit/Popover/PopoverDisclosure"),
  "reakit/Popover/PopoverState": require("reakit/Popover/PopoverState"),
  "reakit/Portal": require("reakit/Portal"),
  "reakit/Portal/Portal": require("reakit/Portal/Portal"),
  "reakit/Provider": require("reakit/Provider"),
  "reakit/Radio": require("reakit/Radio"),
  "reakit/Radio/Radio": require("reakit/Radio/Radio"),
  "reakit/Radio/RadioGroup": require("reakit/Radio/RadioGroup"),
  "reakit/Radio/RadioState": require("reakit/Radio/RadioState"),
  "reakit/Role": require("reakit/Role"),
  "reakit/Role/Role": require("reakit/Role/Role"),
  "reakit/Rover": require("reakit/Rover"),
  "reakit/Rover/Rover": require("reakit/Rover/Rover"),
  "reakit/Rover/RoverState": require("reakit/Rover/RoverState"),
  "reakit/Separator": require("reakit/Separator"),
  "reakit/Separator/Separator": require("reakit/Separator/Separator"),
  "reakit/Tab": require("reakit/Tab"),
  "reakit/Tab/Tab": require("reakit/Tab/Tab"),
  "reakit/Tab/TabList": require("reakit/Tab/TabList"),
  "reakit/Tab/TabPanel": require("reakit/Tab/TabPanel"),
  "reakit/Tab/TabState": require("reakit/Tab/TabState"),
  "reakit/Tabbable": require("reakit/Tabbable"),
  "reakit/Tabbable/Tabbable": require("reakit/Tabbable/Tabbable"),
  "reakit/Toolbar": require("reakit/Toolbar"),
  "reakit/Toolbar/Toolbar": require("reakit/Toolbar/Toolbar"),
  "reakit/Toolbar/ToolbarItem": require("reakit/Toolbar/ToolbarItem"),
  "reakit/Toolbar/ToolbarSeparator": require("reakit/Toolbar/ToolbarSeparator"),
  "reakit/Toolbar/ToolbarState": require("reakit/Toolbar/ToolbarState"),
  "reakit/Tooltip": require("reakit/Tooltip"),
  "reakit/Tooltip/Tooltip": require("reakit/Tooltip/Tooltip"),
  "reakit/Tooltip/TooltipArrow": require("reakit/Tooltip/TooltipArrow"),
  "reakit/Tooltip/TooltipReference": require("reakit/Tooltip/TooltipReference"),
  "reakit/Tooltip/TooltipState": require("reakit/Tooltip/TooltipState"),
  "reakit/VisuallyHidden": require("reakit/VisuallyHidden"),
  "reakit/VisuallyHidden/VisuallyHidden": require("reakit/VisuallyHidden/VisuallyHidden")
};

var deps = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, ReakitPlayground), ReakitSystemBootstrap), ReakitSystemPalette), ReakitSystem), ReakitUtils), Reakit);

function importToRequire(code) {
  return code // { a as b } => { a: b }
  .replace(/([0-9a-z_$]+) as ([0-9a-z_$]+)/gi, "$1: $2") // import { a } from "a" => const { a } = require("b")
  .replace(/import {([^}]+)} from ([^\s;]+);?/g, "const {$1} = require($2);") // import a from "a" => const a = require("a").default || require("a")
  .replace(/import ([\S]+) from ([^\s;]+);?/g, "const $1 = require($2).default || require($2);") // import * as a from "a"
  .replace(/import \* as ([\S]+) from ([^\s;]+);?/g, "const $1 = require($2);") // import a from "a" => const a = require("a").default || require("a")
  .replace(/import (.+),\s?{([^}]+)} from ([^\s;]+);?/g, ["const $1 = require($3).default || require($3);", "const {$2} = require($3);"].join("\n"));
}

function compileComponent(code, depsMap, componentName) {
  if (componentName === void 0) {
    componentName = "Example";
  }

  var defaultDeps = {
    react: React,
    "react-dom": ReactDOM
  };
  var fullCode = "{\n" + importToRequire(code) + "\nif (typeof " + componentName + " !== \"undefined\") {\n  return " + componentName + ";\n}\n}";

  var req = function req(path) {
    if (path in deps) {
      return deps[path];
    }

    if (depsMap && path in depsMap) {
      return depsMap[path];
    }

    if (path in defaultDeps) {
      return defaultDeps[path];
    }

    throw new Error("Unable to resolve path to module '" + path + "'.");
  };

  var _transform = transform(fullCode, {
    transforms: {
      dangerousTaggedTemplateString: true
    },
    objectAssign: true
  }),
      compiledCode = _transform.code; // eslint-disable-next-line no-new-func


  var fn = new Function("require", "React", compiledCode);
  return fn(req, React);
}

function PlaygroundPreview(_ref) {
  var code = _ref.code,
      unstyled = _ref.unstyled,
      modules = _ref.modules,
      update = _ref.update,
      componentName = _ref.componentName,
      htmlProps = _objectWithoutPropertiesLoose(_ref, ["code", "unstyled", "modules", "update", "componentName"]);

  var options = useOptions("PlaygroundPreview", {
    code: code,
    modules: modules,
    componentName: componentName
  }, htmlProps);
  var ref = useRef(null);

  var _useId = unstable_useId({
    baseId: "preview"
  }),
      prefix = _useId.id;

  var _React$useState = useState(null),
      error = _React$useState[0],
      setError = _React$useState[1];

  var handleError = useCallback(function (e) {
    setError(e);
    console.error(e); // eslint-disable-line no-console
  }, []);
  var wrapElement = useCallback(function (children) {
    return /*#__PURE__*/createElement(Provider, {
      unstable_prefix: "" + prefix,
      unstable_system: unstyled ? {} : system
    }, children);
  }, [prefix, unstyled]);

  var _React$useState2 = useState(function () {
    try {
      var Example = compileComponent(options.code, options.modules, options.componentName);
      return wrapElement( /*#__PURE__*/createElement(Example, null));
    } catch (e) {
      handleError(e);
    }

    return null;
  }),
      rendered = _React$useState2[0],
      setRendered = _React$useState2[1];

  var unmount = useCallback(function () {
    if (ref.current) {
      setRendered(null);
      unmountComponentAtNode(ref.current);
    }
  }, []);
  useEffect(function () {
    var timer = setTimeout(function () {
      setError(null);

      try {
        var Example = compileComponent(options.code, options.modules, options.componentName);
        unmount();
        render(wrapElement( /*#__PURE__*/createElement(Example, null)), ref.current);
      } catch (e) {
        unmount();
        handleError(e);
      }
    }, 500);
    return function () {
      return clearTimeout(timer);
    };
  }, [options.code, options.modules, options.componentName, wrapElement, handleError, unmount]);
  useEffect(function () {
    // Ensure that we unmount the React component when the effect is destroyed.
    return function () {
      return unmount();
    };
  }, [unmount]);
  htmlProps = useProps("PlaygroundPreview", options, htmlProps);
  return /*#__PURE__*/createElement(ErrorBoundary, null, /*#__PURE__*/createElement("div", htmlProps, error && /*#__PURE__*/createElement(ErrorMessage, {
    error: error
  }), /*#__PURE__*/createElement("div", {
    ref: ref
  }, wrapElement(rendered))));
}

export { PlaygroundPreview };
